import React from 'react';
import { AiTokenConsumptionContainer } from '../styles';
import AiTokenConsumptionUsage from './AiTokenConsumptionUsage';
import AiTokenConsumptionDailyUsage from './AiTokenConsumptionDailyUsage';
import AiTokenConsumptionBotUsage from './AiTokenConsumptionBotUsage';

const AiTokenConsumptionSummary: React.FC = () => {
  return (
    <AiTokenConsumptionContainer>
      <AiTokenConsumptionUsage />
      <AiTokenConsumptionBotUsage />
      <AiTokenConsumptionDailyUsage />
    </AiTokenConsumptionContainer>
  );
};

export default AiTokenConsumptionSummary;
